// 题型枚举
export const QuestionType = {
    SINGLE_CHOICE: "single_choice", // 单选
    MULTIPLE_CHOICE: "multiple_choice", // 多选
    TRUE_FALSE: "true_false", // 判断
    FILL_BLANK: "fill_blank", // 填空
    ESSAY: "essay", // 简答
};
// 练习模式
export const PracticeMode = {
    SEQUENTIAL: "sequential", // 顺序练习
    RANDOM: "random", // 随机练习
    MOCK: "mock", // 模拟考试
    CHAPTER: "chapter", // 按章节
    TYPE: "type", // 按题型
    WRONG: "wrong", // 错题练习
    FAVORITE: "favorite", // 收藏练习
    SPEED: "speed", // 考前速览
};
// 会话状态
export const SessionStatus = {
    ACTIVE: "active",
    COMPLETED: "completed",
    ABORTED: "aborted",
};
// 导入来源
export const ImportSource = {
    AI_IMPORT: "ai_import",
    MANUAL: "manual",
    PHOTO: "photo",
    DOCUMENT: "document",
};
// 导入状态
export const ImportStatus = {
    PROCESSING: "processing",
    COMPLETED: "completed",
    FAILED: "failed",
};
// 通用响应状态码
export const ErrorCode = {
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    NOT_FOUND: "NOT_FOUND",
    VALIDATION_ERROR: "VALIDATION_ERROR",
    INTERNAL_ERROR: "INTERNAL_ERROR",
    RATE_LIMITED: "RATE_LIMITED",
};
//# sourceMappingURL=enums.js.map